import { Link } from '@inertiajs/react'

const statusColors = {
  new: 'bg-blue-100 text-blue-800',
  contacted: 'bg-yellow-100 text-yellow-800',
  qualified: 'bg-purple-100 text-purple-800',
  converted: 'bg-green-100 text-green-800',
  lost: 'bg-gray-100 text-gray-800'
}

const statusLabels = {
  new: 'Nouveau',
  contacted: 'Contacté',
  qualified: 'Qualifié',
  converted: 'Converti',
  lost: 'Perdu'
}

const projectTypeLabels = {
  buyer: 'Acheteur',
  seller: 'Vendeur',
  tenant: 'Locataire'
}

export default function RecentLeadsList({ leads }) {
  if (!leads || leads.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>Aucun lead récent</p>
        <Link href="/leads" className="text-primary-600 hover:text-primary-700 text-sm mt-2 inline-block">
          Voir tous les leads →
        </Link>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {leads.map((lead) => (
        <Link
          key={lead.id}
          href={`/leads/${lead.id}`}
          className="block p-3 rounded-lg border border-gray-200 hover:border-primary-300 hover:bg-primary-50 transition-colors"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="font-medium text-gray-900">
                  {lead.first_name} {lead.last_name}
                </h4>
                <span className={`px-2 py-0.5 text-xs font-medium rounded ${statusColors[lead.status]}`}>
                  {statusLabels[lead.status]}
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-1">{lead.email}</p>
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <span>{projectTypeLabels[lead.project_type]}</span>
                {lead.budget && (
                  <>
                    <span>•</span>
                    <span>{(lead.budget).toLocaleString('fr-FR')}€</span>
                  </>
                )}
                {lead.lead_score && (
                  <>
                    <span>•</span>
                    <span>Score: {lead.lead_score.score}/100</span>
                  </>
                )}
              </div>
            </div>
            <div className="text-xs text-gray-400">
              {new Date(lead.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}
